import { PageTypeId } from '../const';
import { ModDocuments } from '../../../components/Icons/ModDocuments';
import { ModInvoices } from '../../../components/Icons/ModInvoices';
import { ModSafety } from '../../../components/Icons/ModSafety';
import { ModSavedFilters } from '../../../components/Icons/ModSavedFilters';
import { ModBureaus } from '../../../components/Icons/ModBureaus';
import { ModCalculationScheme } from '../../../components/Icons/ModCalculationScheme';
import { ModPhases } from '../../../components/Icons/ModPhases';
import { ModTags } from '../../../components/Icons/ModTags';
import { FolderOpen } from '../../../components/Icons/FolderOpen';
import { ModConnect } from '../../../components/Icons/ModConnect';
import { ModSubscriptions } from '../../../components/Icons/ModSubscriptions';
import { FolderGear } from '../../../components/Icons/FolderGear';
import { ModPayments } from '../../../components/Icons/ModPayments';
import { ModUsers } from '../../../components/Icons/ModUsers';
import { ModGossip } from '../../../components/Icons/ModGossip';
import { ModRoles } from '../../../components/Icons/ModRoles';
import { ModWorkflow } from '../../../components/Icons/ModWorkflow';
import { ModFormBuilder } from '../../../components/Icons/ModFormBuilder';
import { ModRateClasses } from '../../../components/Icons/ModRateClasses';
import { ModSurveys } from '../../../components/Icons/ModSurveys';
import { ModCaoWages } from '../../../components/Icons/ModCaoWages';
import { ModJobs } from '../../../components/Icons/ModJobs';
import { ModTextModel } from '../../../components/Icons/ModTextModel';
import { ModIllnessCases } from '../../../components/Icons/ModIllnessCases';
import { ModApplications } from '../../../components/Icons/ModApplications';
import { ModReservations } from '../../../components/Icons/ModReservations';
import { ModAutomationManager } from '../../../components/Icons/ModAutomationManager';
import { ModEmployers } from '../../../components/Icons/ModEmployers';
import { ModCaowijer } from '../../../components/Icons/ModCaowijer';
import { ModShare } from '../../../components/Icons/ModShare';
import { ModCandidates } from '../../../components/Icons/ModCandidates';
import { ModTimecards } from '../../../components/Icons/ModTimecards';
import { ModComponentModel } from '../../../components/Icons/ModComponentModel';
import { ModAuditTrail } from '../../../components/Icons/ModAuditTrail';
import { ModPayslips } from '../../../components/Icons/ModPayslips';
import { ModContracts } from '../../../components/Icons/ModContracts';
import { ModModelMatrix } from '../../../components/Icons/ModModelMatrix';
import { ModLabel } from '../../../components/Icons/ModLabel';
import { ModDomainValues } from '../../../components/Icons/ModDomainValues';
import { Dashboard } from '../../../components/Icons/Dashboard';
import { NavigationIcons } from '../types';
import { ModFlexNetManager } from '../../../components/Icons/ModFlexNetManager';
import { ModCandidatePension } from '../../../components/Icons/ModCandidatePension';
import { ModAssessment } from '../../../components/Icons/ModAssessment';
import { ModDocumentTemplate } from '../../../components/Icons/ModDocumentTemplate';
import { ModFlexwijerWml } from '../../../components/Icons/ModFlexwijerWml';
import { QuestionCircle } from '../../../components/Icons/QuestionCircle';
import { Help } from '../../../components/Icons/Help';
import { ModCaoNews } from '../../../components/Icons/ModCaoNews';
import { ModMapping } from '../../../components/Icons/ModMapping';

export const defaultNavigationIcons: NavigationIcons = {
	[PageTypeId.UserList]: ModUsers,
	[PageTypeId.RoleList]: ModRoles,
	[PageTypeId.ConnectIncomingList]: ModConnect,
	[PageTypeId.ConnectIncomingLogList]: ModConnect,
	[PageTypeId.ConnectOutgoingList]: ModConnect,
	[PageTypeId.ConnectOutgoingLogList]: ModConnect,
	[PageTypeId.ConnectSettings]: ModConnect,
	[PageTypeId.ConnectEmailSenderAuthList]: ModConnect,
	[PageTypeId.ConnectApiUserList]: ModConnect,
	[PageTypeId.ConnectorList]: ModConnect,
	[PageTypeId.ConnectCustomerAccessRequestList]: ModConnect,
	[PageTypeId.ConnectFSApiLogList]: ModConnect,
	[PageTypeId.ConnectDashboard]: ModConnect,
	[PageTypeId.CustomerList]: ModSubscriptions,
	[PageTypeId.LabelList]: ModLabel,
	[PageTypeId.LabelPagesList]: ModLabel,
	[PageTypeId.LabelTemplates]: ModLabel,
	[PageTypeId.LabelTranslations]: ModLabel,
	[PageTypeId.TagList]: ModTags,
	[PageTypeId.NewsAdminList]: ModGossip,
	[PageTypeId.NewsList]: ModGossip,
	[PageTypeId.CommunitiesList]: ModGossip,
	[PageTypeId.CommentList]: ModGossip,
	[PageTypeId.SavedFilterMyFiltersList]: ModSavedFilters,
	[PageTypeId.SavedFilterOtherUsersFiltersList]: ModSavedFilters,
	[PageTypeId.SavedFilterSystemFiltersList]: ModSavedFilters,
	[PageTypeId.SavedFilterAlertLogsList]: ModSavedFilters,
	[PageTypeId.RateClassesList]: ModRateClasses,
	[PageTypeId.CalculationSchemeList]: ModCalculationScheme,
	[PageTypeId.DomainValuesList]: ModDomainValues,
	[PageTypeId.ModelMatrixList]: ModModelMatrix,
	[PageTypeId.ModelMatrixInstanceList]: ModModelMatrix,
	[PageTypeId.ComponentModelList]: ModComponentModel,
	[PageTypeId.TextModelList]: ModTextModel,
	[PageTypeId.AuditTrailList]: ModAuditTrail,
	[PageTypeId.SettingList]: ModAuditTrail,
	[PageTypeId.SurveyList]: ModSurveys,
	[PageTypeId.SurveyAdminList]: ModSurveys,
	[PageTypeId.Dashboard]: Dashboard,
	[PageTypeId.ManagementInformation]: Dashboard,
	[PageTypeId.AgencyList]: ModBureaus,
	[PageTypeId.AgencyStructure]: ModBureaus,
	[PageTypeId.EmployerList]: ModEmployers,
	[PageTypeId.EmployerContactPersonsList]: ModEmployers,
	[PageTypeId.DealList]: ModEmployers,
	[PageTypeId.SupplierOrganizationList]: ModEmployers,
	[PageTypeId.CandidateList]: ModCandidates,
	[PageTypeId.ProformaList]: ModCandidates,
	[PageTypeId.CandidateChangeList]: ModCandidates,
	[PageTypeId.CandidateReservationList]: ModReservations,
	[PageTypeId.CandidatePeriodicComponentsList]: ModCandidates,
	[PageTypeId.CandidatePhaseList]: ModPhases,
	[PageTypeId.ContractList]: ModContracts,
	[PageTypeId.ContractBulkUpdateRequestList]: ModContracts,
	[PageTypeId.DocumentList]: ModDocuments,
	[PageTypeId.DocumentTemplateList]: ModDocumentTemplate,
	[PageTypeId.TimecardList]: ModTimecards,
	[PageTypeId.InvoiceList]: ModInvoices,
	[PageTypeId.InvoicePurchaseInvoice]: ModInvoices,
	[PageTypeId.InvoiceComponentsList]: ModInvoices,
	[PageTypeId.PayslipList]: ModPayslips,
	[PageTypeId.IllnessList]: ModIllnessCases,
	[PageTypeId.PaymentList]: ModPayments,
	[PageTypeId.JobList]: ModJobs,
	[PageTypeId.ApplicationList]: ModApplications,
	[PageTypeId.TaskList]: ModWorkflow,
	[PageTypeId.ActivityList]: ModWorkflow,
	[PageTypeId.CaoList]: ModCaowijer,
	[PageTypeId.CustomCaoList]: ModCaowijer,
	[PageTypeId.CustomCaoInstanceList]: ModCaowijer,
	[PageTypeId.CaoInstanceList]: ModCaowijer,
	[PageTypeId.CaoNewsList]: ModCaoNews,
	[PageTypeId.CaoWagesList]: ModCaoWages,
	[PageTypeId.CaoWagesRequestsList]: ModAssessment,
	[PageTypeId.CaoWmlList]: ModFlexwijerWml,
	[PageTypeId.ShareJobBoardList]: ModShare,
	[PageTypeId.ShareJobBoardInstanceList]: ModShare,
	[PageTypeId.ShareLogList]: ModShare,
	[PageTypeId.ShareJobPostList]: ModShare,
	[PageTypeId.FormDesignerList]: ModFormBuilder,
	[PageTypeId.FormUserList]: ModFormBuilder,
	[PageTypeId.FlexNetBundleList]: ModFlexNetManager,
	[PageTypeId.FlexNetCustomerList]: ModFlexNetManager,
	[PageTypeId.FlexNetHostList]: ModFlexNetManager,
	[PageTypeId.FlexNetHostSettings]: ModFlexNetManager,
	[PageTypeId.PensionList]: ModCandidatePension,
	[PageTypeId.AutomationList]: ModAutomationManager,
	[PageTypeId.AutomationLogList]: ModAutomationManager,
	[PageTypeId.SafetyList]: ModSafety,
	[PageTypeId.BackofficeJournalTransferFilesList]: FolderOpen,
	[PageTypeId.BackofficePaymentTransferFilesList]: FolderGear,
	[PageTypeId.BackofficeProcessingList]: FolderOpen,
	[PageTypeId.BackofficeIndex]: FolderOpen,
	[PageTypeId.Faq]: Help,
	[PageTypeId.Help]: QuestionCircle,
	[PageTypeId.DocumentSettingsList]: ModDocuments,
	[PageTypeId.ApplicationForm]: ModApplications,
	[PageTypeId.SurveyListOptOutList]: ModSurveys,
	[PageTypeId.CandidateCandidateStatusMapping]: ModMapping,
	[PageTypeId.DomainValuesMapping]: ModMapping,
	[PageTypeId.DomainValuesCAOMapping]: ModMapping,
	[PageTypeId.CustomerSubscriptionList]: ModSubscriptions,
	[PageTypeId.CustomerSubscriptionSettingList]: ModSubscriptions,
	[PageTypeId.CustomerInvoiceList]: ModSubscriptions,
	[PageTypeId.SubscriberList]: ModJobs,
};
